<template>
  <b-modal
    :id="id"
    hide-footer
    hide-header
    hide-header-close
    centered
    no-close-on-esc
    no-close-on-backdrop
  >
    <div class="p-2 text-center relative">
      <BButton
        variant="link"
        class="absolute top-[.5rem] right-[.5rem]"
        @click="() => {
          $emit('close')
          $bvModal.hide(id)
        }"
      >
        <BIcon
          icon="x"
          class="scale-150"
          variant="secondary"
        />
      </BButton>
      <div class="loading-icon mb-3">
        <img
          src="https://storage.googleapis.com/komerce/Komads/komads-whitelisted-confetti.svg"
          alt="Klaim Berhasil"
          class="mx-auto"
          width="250px"
        >
      </div>
      <div class="mb-2">
        <h2 class="font-semi-bold text-black text-xl mb-[.5rem]">
          Selamat! {{ data.isAllClaimed ? 'Semua reward' : 'Reward' }} berhasil diklaim!
        </h2>
        <p class="text-secondary">
          Anda berhasil mendapatkan 1 akun whitelist setelah  mencapai spending <span class="font-semibold">{{ data.claimAmount }}</span>
        </p>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'modal-success-claim',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style scoped>
.text-black {
  color: #333333;
}

.text-secondary {
  color: #6c757d;
}
</style>
